/* eslint-disable no-unused-vars */
import { signIn, signOut, useSession } from 'next-auth/react';
import React, { useEffect, useRef, useState } from 'react';

import { fetchVisitsForWebCalendar } from '../../../services/visits';
import { convertWorkshopCalendarVisits } from '../../../utils/visitConverter';
import VisitsCalendarScreen from '../../scenes/visits/VisitsCalendarScreen';

const VisitsCalendarScreenContainer = () => {
  const { data: session, status } = useSession();
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isLegendModalVisible, setIsLegendModalVisible] = useState(false);
  const [error, setError] = useState(null);
  const startEndDateRef = useRef(null);
  const visitsRef = useRef([]);

  const loadVisits = async () => {
    setIsLoading(true);
    try {
      await refreshVisitsCalendar();
    } catch (err) {
      setError(err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (session?.error === 'RefreshAccessTokenError' || status === 'unauthenticated') {
      signIn(); // Force sign in to hopefully resolve error
    }
    if (session?.user && status === 'authenticated') {
      // fetchUserProfileHandler(session?.user);
      loadVisits();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.user?.accessToken, session?.error, status]);

  const onRefresh = async () => {
    setIsRefreshing(true);
    await refreshVisitsCalendar(startEndDateRef.current);
    setIsRefreshing(false);
  };

  const saveVisitsForCalendar = async (data) => {
    if (data) {
      visitsRef.current = convertWorkshopCalendarVisits(data);
    }
  };

  const refreshVisitsCalendar = async (value) => {
    await fetchVisitsForWebCalendar(
      session.user?.profileId,
      value ?? startEndDateRef.current,
      setError,
      saveVisitsForCalendar,
      logoutHandler,
    );
  };

  const getCalendarData = async (fetchInfo, successCallback, failureCallback) => {
    if (fetchInfo?.start) {
      startEndDateRef.current = fetchInfo;
    }
    await fetchVisitsForWebCalendar(
      session.user?.profileId,
      fetchInfo,
      setError,
      saveVisitsForCalendar,
      logoutHandler,
    );

    try {
      successCallback(
        visitsRef.current.map((item) => {
          return {
            title: item.title,
            start: item.start,
            resource: item.resource,
          };
        }),
      );
    } catch (err) {
      console.log(err);
    }
  };

  const logoutHandler = async () => {
    await signOut();
  };

  return (
    <VisitsCalendarScreen
      status={status}
      getCalendarData={getCalendarData}
      isLegendModalVisible={isLegendModalVisible}
      setIsLegendModalVisible={setIsLegendModalVisible}
      isRefreshing={isRefreshing}
      onRefresh={onRefresh}
      error={error}
    />
  );
};

export default VisitsCalendarScreenContainer;
